<app-transaction-history
  [entityId]="entityId"
  [config]="transactionHistoryConfig"
  [transactionService]="transactionService"
  (transactionSelected)="onTransactionSelected($event)"
  (transactionUpdated)="onTransactionUpdated($event)"
  (loadingChange)="onLoadingChange($event)"
  [type]="type"
  [hideExchangeType]="hideExchangeType"
  [initialSearch]="initialSearch"
>
  <!-- Entity-specific transaction details content projection -->
  @if (showTransactionDetails) {
    <div slot="transaction-details">
      <ng-container *ngTemplateOutlet="transactionDetailsTemplate!; context: transactionDetailsContext"> </ng-container>
    </div>
  }
</app-transaction-history>
